import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { connect } from "react-redux";

import LayoutWrapper from "../../../../common/LayoutWrapper";
import AdviserDocsWrapper from "../../../../common/AdviserDocsWrapper";
import GetStarted from "../../../../components/cases/documents/careDirective/GetStarted";
import FoodDrink from "../../../../components/cases/documents/careDirective/FoodDrink";
import Clothing from "../../../../components/cases/documents/careDirective/Clothing";
import BodyCare from "../../../../components/cases/documents/careDirective/BodyCare";
import Other from "../../../../components/cases/documents/careDirective/Other";
import IndividualWishes from "../../../../components/cases/documents/careDirective/IndividualWishes";
import Overview from "../../../../components/cases/documents/careDirective/Overview";

import { customTab, nextTab, preTab } from "../../../../redux/slices/TabSlices";
import { getAssetsOnBoardingList } from "../../../../redux/slices/features/assetsOnBoardingSlice";
import { resetCard } from "../../../../redux/slices/CardSlices";
import { careDirectiveSteps } from "../../../../constants/constants";
import DocSwiper from "../../../../common/Swipers/DocsSwiper";
import { getCareDirectiveData } from "../../../../services/documentServices";
import {
  getUserIdFromLocalStorage,
  overAllStatus,
} from "../../../../utils/Utilities";

import "../../../../components/yourAssets/BOA/BOA.scss";
import { useLocation, useParams } from "react-router-dom";
import {
  LinkButton,
  PrimaryButton,
  SecondaryButton,
} from "../../../../common/Buttons";
import { useTranslation } from "react-i18next";

const CareDirective = ({
  currentTab,
  nextTab,
  preTab,
  customTab,
  resetCard,
}) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const [steps, setSteps] = useState(careDirectiveSteps);
  const [buttonDisabled, setButtonDisabled] = useState(false);

  const handleResetCard = () => {
    resetCard();
  };
  const handleNext = () => {
    handleResetCard();
    nextTab();
  };
  const handleBack = () => {
    handleResetCard();
    preTab();
  };
  const handleCustomTab = (val) => {
    customTab(val);
  };
  const tabMaping = {
    1: (
      <GetStarted
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
      />
    ),
    2: (
      <FoodDrink
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
      />
    ),
    3: (
      <Clothing
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
      />
    ),
    4: (
      <BodyCare
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
      />
    ),
    5: (
      <Other
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
      />
    ),
    6: (
      <IndividualWishes
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
      />
    ),
    7: (
      <Overview
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
      />
    ),
  };
  const dispatch = useDispatch();
  const tabStatuses = useSelector(
    (state) => state.assetsOnBoarding.assetsSuggestionBoxText
  );

  async function fetchData() {
    const arr = [];
    const result = await getCareDirectiveData(id);
    if (result?.success) {
      const {
        foodDrink,
        cloth,
        bodyCare,
        otherCareDirective,
        startedStepStatus,
      } = result.payLoad;

      const array = [
        startedStepStatus,
        foodDrink?.stepStatus || 0,
        cloth?.stepStatus || 0,
        bodyCare?.stepStatus || 0,
        otherCareDirective?.stepStatus || 0,
        2,
        2,
      ];

      steps.forEach((elem, index) => {
        if (index !== steps.length - 1) {
          arr.push({ ...elem, stepStatus: array[index] });
        }
        if (index === steps.length - 1) {
          const res = overAllStatus(array);
          arr.push({ ...elem, stepStatus: res ? 2 : 1 });
        }
      });

      setSteps(arr);
    }
  }

  useEffect(() => {
    fetchData();
  }, [currentTab]);

  useEffect(() => {
    dispatch(getAssetsOnBoardingList());
  }, []);

  const renderTab = () => {
    return tabMaping[currentTab];
  };
  return (
    <>
      <AdviserDocsWrapper pageName="Care Directives">
        <LayoutWrapper
          borderShadow={true}
          minHeight="calc(100vh - 120px) !important"
        >
          <DocSwiper
            showTooltip={false}
            tab={currentTab}
            back={handleBack}
            custom={handleCustomTab}
            list={steps}
          />

          {renderTab()}

          {currentTab !== 7 ? (
            <div
              style={{
                minWidth: "310px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <SecondaryButton
                title={t("save-and-continue")}
                bgColor="#E8D7E5"
                borderRadius="14px"
                width="180px"
                marginLeft="20px"
                border="none"
                hoverBgColor="color.magentaLight1"
                textTransform="initial"
                padding="0rem"
                height="2.7rem"
                form="form_submit"
                type="submit"
                disabled={buttonDisabled}
              />

              <LinkButton
                title={t("skip-for-now")}
                bgColor="color.transparent"
                borderRadius="14px"
                fontSize="0.8rem"
                width="110px"
                marginLeft="0px"
                border="none"
                click={handleNext}
                textTransform="initial"
              />
            </div>
          ) : (
            <div
              className="button-container-2"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <PrimaryButton
                title={t("save")}
                bgColor="#E8D7E5"
                color="#444561"
                padding="10px 60px"
                textTransform="initial"
                borderRadius={"18px"}
                boxShadow={0}
              />
            </div>
          )}
        </LayoutWrapper>
      </AdviserDocsWrapper>
    </>
  );
};

function mapStateToProps(state) {
  return {
    currentTab: state.currentTab.currentTab,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    nextTab: () => dispatch(nextTab()),
    preTab: () => dispatch(preTab()),
    customTab: (num) => dispatch(customTab(num)),
    resetCard: () => dispatch(resetCard()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CareDirective);
